<template>
    <b-overlay :show="classificationCompStatus"  rounded="sm">
      <!--<div class="section-header row">
        <h1 class="heading">Auto Classification - Step {{ classificationStage+1 }} of 4</h1>

        
      </div>-->
      <b-row v-if="classificationStage === 0 || classificationStage === 4" class="categories-select">
        <b-col>
          <!--<b-row>
            <b-col>
              <b-form-group
                    id="select-api-method"
                    label="Select Method(Api)"
                    label-for="select-method"
                  >
                  <b-form-select id="select-method" v-model="form.method" :options="options"></b-form-select>
              </b-form-group>
              <b-form-group
                    id="select-chunk-method"
                    label="Select Batching/Chunking Method"
                    label-for="chunk-method"
                  >
                  <b-form-select id="chunking-method" v-model="form.chunking" :options="ch_options"></b-form-select>
              </b-form-group>
              <b-form-group
                    id="input-group-description"
                    label="(Optional) - I have a collection of [Research Documents/Patents/Articles/Social Media Posts] related to:"
                    label-for="input-description"
                  >
                    <b-form-textarea
                      id="input-description"
                      v-model.trim="form.description"
                      v-validate="{ required: false, max: 1000 }"
                      placeholder=""
                      size="lg"
                      data-vv-name="description"
                      rows="5"
                    ></b-form-textarea>
              </b-form-group>
              <b-form-group
                    id="input-group-objective"
                    label="(Optional) - I am working to/My aim is to/My research is related to:"
                    label-for="input-objective"
                  >
                    <b-form-textarea
                      id="input-objective"
                      v-model.trim="form.objective"
                      v-validate="{ required: false, max: 1000 }"
                      placeholder=""
                      size="lg"
                      data-vv-name="objective"
                      rows="5"
                    ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right" cols="12">
              <div class="form-footer">
                  <b-btn variant="primary" size="lg" @click="setStage(1)">
                    Start Auto Classification
                  </b-btn>
              </div>
            </b-col>
          </b-row>-->
          <b-row>
            <b-col cols="8">
                <p>Welcome to <b>Mynd - FilterAi</b>, Use AI to automatically build filters based on your desired classification scheme of categories and subcategories.</p>
                <p v-if="batchingStatus === 'No'" class="text-error"><b>System Notice:</b> The model is missing the necessary batching of data required for auto-classification</p>
            </b-col>
            <b-col>
                <img width="50" src="/images/sparks-on.png" alt="Mynd - FiltersAi" />
            </b-col>
          </b-row>
          <b-row v-if="batchingProgress" class="mt-3">
            <b-col>
                <p><b>{{ batchingProgressMsg || 'Batching' }} - {{batchingProgressValue}}%</b></p>
                <b-progress :max="100">
                    <b-progress-bar :value="batchingProgressValue"></b-progress-bar>
                </b-progress>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
                <b-btn v-if="batchingStatus === 'No' && !classificationStatus && !batchingProgress" variant="primary" size="md" @click="startBatching()">
                    Start Batching
                </b-btn>
                <b-btn v-else variant="primary" size="md" @click="setStage(1)" :disabled="batchingStatus === 'No'">
                    Lets Start
                </b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="classificationStage === 1" class="categories-select">
        <b-col>
          <b-row class="d-flex header">
            <!--<b-col cols="12">
              <h5><b>Step 1:</b> Define topic, categories &amp; sub-categories</h5>
              <p>Include Other/Uncategorized if needed</p>
            </b-col>-->
            <b-col cols="12" class="d-flex justify-content-start">
              <p><b>Topic:</b>&nbsp;</p><a class="cursor-pointer" @click="openTopicModal">{{ modelTopic? modelTopic : 'Please define topic for better results' }}</a>
            </b-col>
            <b-col cols="12" class="catform mt-4" v-if="showCatForm">
              <b-form-group id="input-group-name" label-for="input-name">
                <b-form-input
                  id="input-name"
                  ref="catname"
                  v-model.trim="form.catname"
                  v-validate="{ required: true, max: 100 }"
                  type="text"
                  placeholder="Category Title"
                  size="md"
                  data-vv-name="Category Title"
                  v-on:keyup.enter="addCategory(catEditing)"
                ></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-desc" label-for="input-desc">
                <b-input-group>
                  <b-form-textarea
                    id="input-desc"
                    v-model.trim="form.catdesc"
                    v-validate="{ required: true, max: 500 }"
                    placeholder="Category Description"
                    size="md"
                    data-vv-name="desc"
                    v-on:keyup.enter="addCategory(catEditing)"
                  ></b-form-textarea>
                  <b-input-group-append>
                    <b-btn variant="outline-secondary" @click="suggestDescription(form.catname, 0)" size="sm">
                      <img src="/images/sparks.png" width="25" alt="Mynd - Sparks">
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-start mt-2" v-if="!showCatForm">
              <b-btn variant="primary" size="sm" @click="showCategory">
                <i class="fa fa-plus" /> Category
              </b-btn>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-start mt-2" v-else>
              <b-btn variant="primary" size="sm" @click="addCategory(catEditing)"  class="ml-auto">
                <i class="fa fa-save" /> {{ catEditing !== null ? 'Update' : 'Save' }}
              </b-btn>
              <b-btn variant="primary" size="sm" @click="showCategory" class="ml-1">
                <i class="fa fa-times" /> Close
              </b-btn>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-list-group class="added-categories">
                <!-- <b-list-group-item v-for="(cat, n) in categories" :key="n" :class="{'default': categories.length && categories.length === 1 && cat.title === 'Others'}" :disabled="categories.length && categories.length === 1 && cat.title === 'Others'"> -->
                  <b-list-group-item v-for="(cat, n) in categories" :key="n">
                  <b-row>
                    <b-col class="d-flex justify-content-between align-items-center">
                      <!-- <span><strong>Title:</strong> {{ cat.title }} {{ categories.length && cat.title === 'Others' ? '(Added automatically by default)' : '' }}<br><strong>Description:</strong> {{ cat.description? cat.description:"No Description" }}</span> -->
                      <span><strong>Title:</strong> {{ cat.title }}<br><strong>Description:</strong> {{ cat.description? cat.description:"No Description" }}</span>
                      <b-dropdown
                        v-if="!isActive(n)"
                        variant="outline-secondary"
                        toggle-class="text-decoration-none"
                        right
                        no-caret
                      >
                        <template slot="button-content"
                          ><i class="fa fa-ellipsis-v"
                        /></template>
                        <b-dropdown-item @click="activateBlock(n)">
                          <i class="fa fa-plus" /> SubCategory
                        </b-dropdown-item>
                        <b-dropdown-item @click="editCategory(n)">
                          <i class="fa fa-edit" /> Edit
                        </b-dropdown-item>
                        <b-dropdown-item @click="removeCategory(n)">
                          <i class="fa fa-trash" /> Delete
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2" v-if="isActive(n)">
                    <b-col cols="12" class="catform">
                      <b-form-group id="input-group-name-subcat" label-for="input-name-subcat">
                        <b-form-input
                          id="input-name-subcat"
                          :ref="'subcatname'+n"
                          v-model.trim="form.subcatname"
                          v-validate="{ required: true, max: 100 }"
                          type="text"
                          placeholder="Subcategory Title"
                          size="md"
                          data-vv-name="Subcategory Title"
                          v-on:keyup.enter="addSubCategory(n, subcatEditing)"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group id="input-group-desc-subcat" label-for="input-desc-subcat">
                        <b-input-group>
                          <b-form-textarea
                            id="input-desc-subcat"
                            v-model.trim="form.subcatdesc"
                            v-validate="{ required: true, max: 500 }"
                            placeholder="Subcategory Description"
                            size="md"
                            data-vv-name="desc"
                            v-on:keyup.enter="addSubCategory(n, subcatEditing)"
                          ></b-form-textarea>
                          <b-input-group-append>
                            <b-btn variant="outline-secondary" @click="suggestDescription(form.subcatname, 1)" size="sm">
                              <img src="/images/sparks.png" width="25" alt="Mynd - Sparks">
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-start mt-2">
                      <b-btn variant="primary" size="sm" @click="addSubCategory(n, subcatEditing)" class="ml-auto">
                        <i class="fa fa-save" /> {{ subcatEditing !== null ? 'Update' : 'Save' }}
                      </b-btn>
                      <b-btn variant="primary" size="sm" @click="activateBlock(null)" class="ml-1">
                        <i class="fa fa-times" /> Close
                      </b-btn>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col class="d-flex justify-content-start align-items-center">
                      <p class="mb-0">
                        <strong>Subcategories</strong> 
                      </p>
                      <b-btn variant="outline-secondary" size="sm" @click="activateBlock(n)" class="ml-2 mr-auto">
                        <i class="fa fa-plus" /> Add
                      </b-btn>
                    </b-col>
                    <b-col style="margin-top:10px; min-width: 100%">
                      <b-list-group class="added-categories">
                        <!-- <b-list-group-item v-for="(cat, s) in categories[n].subcats" :key="s" class="d-flex justify-content-between align-items-center p-1" :class="{'default': categories.length && categories.length === 1 && cat.title === 'Others'}" :disabled="categories.length && categories.length === 1 && cat.title === 'Others'"> -->
                          <b-list-group-item v-for="(cat, s) in categories[n].subcats" :key="s" class="d-flex justify-content-between align-items-center p-1">
                          <span class="pl-2">Title: <i>{{ cat.title }}</i><br>Description: <i>{{ cat.description? cat.description:"No Description" }}</i></span>
                          
                          <b-dropdown
                            variant="outline-transparent"
                            size="sm"
                            toggle-class="text-decoration-none"
                            right
                            no-caret
                          >
                            <template slot="button-content"
                              ><i class="fa fa-ellipsis-h"
                            /></template>
                            <b-dropdown-item size="sm" @click="editSubCategory(n, s)">
                              <i class="fa fa-edit" /> Edit
                            </b-dropdown-item>
                            <b-dropdown-item size="sm" @click="removeSubCategory(n, s)">
                              <i class="fa fa-trash" /> Delete
                            </b-dropdown-item>
                          </b-dropdown>
                          <!--<b-btn variant="secondary-outline" size="sm" @click="editSubCategory(n, s)" class="ml-auto">
                            <i class="fa fa-edit" />
                          </b-btn>
                          <b-btn variant="secondary-outline" size="sm" @click="removeSubCategory(n, s)">
                            <i class="fa fa-trash" />
                          </b-btn> -->
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <b-row  class="header">
            <b-col cols="12">
              <div class="form-footer d-flex justify-content-between">
                <b-btn variant="outline-secondary" size="sm" @click="setStage(0)">
                  Back
                </b-btn>
                  <b-btn v-if="stats && stats.status<0" variant="danger" size="sm" class="ml-auto mr-2" @click="delClassifiedData">
                    <i class="fa fa-trash" /> Discard
                  </b-btn>
                <b-btn variant="primary" size="sm" class="ml-auto mr-2" @click="getClassifiedData()" v-if="step===5 && stats.percentage_completion===100">
                  Review Results
                </b-btn>
                <b-btn variant="primary" size="sm" :disabled="!categories.length || batchingStatus === 'No'" @click="startClassification()">
                  {{ step===5 && stats.percentage_completion===100 ? "Update":"Start" }} Classification
                </b-btn>
              </div>
            </b-col>
            <b-col cols="12">
              <p v-if="batchingStatus === 'No'" class="mt-2 text-error"><b>System Notice:</b> Model compatibility check failed. Please re-run the model calculation to resolve the issue</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="classificationStage === 2" class="categories-select">
        <b-col>
          <b-row>
            <b-col>
              <h5><b>Step 2:</b> Classification + Grouping</h5>
              
              <div class="d-flex justify-content-between mb-1">
                <b-badge variant="danger" v-if="stats.status<0">{{stats.description}}</b-badge>
                <b-badge v-else variant="outline-secondary">{{ step<5? stats.description:step===5 && stats.percentage_completion===100 ? "Classification process complete!" : stats.description }}</b-badge>
                <!--<b-badge variant="outline-secondary"> {{ stats.status > 0? ((stats.status*5) + ((stats.percentage_completion/100)*70)).toFixed(2):0 }}% complete </b-badge>-->
              </div>
              <b-list-group>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Preparing Schema:</strong>&nbsp;&nbsp;&nbsp;{{ step<=1? 50:100 }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="100"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Applying Classification:</strong>&nbsp;&nbsp;&nbsp;{{ step === 2? stats.percentage_completion.toFixed(2) : step > 2? 100:0 }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="step === 2? stats.percentage_completion.toFixed(2) : step > 2? 100:0"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Finding Similarity:</strong>&nbsp;&nbsp;&nbsp;{{ step === 3? stats.percentage_completion.toFixed(2) : step > 3? 100:0 }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="step === 3? stats.percentage_completion.toFixed(2) : step > 3? 100:0"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Grouping as filters:</strong>&nbsp;&nbsp;&nbsp;{{ step === 4? stats.percentage_completion.toFixed(2) : step > 4? 100:0 }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="step === 4? stats.percentage_completion.toFixed(2) : step > 4? 100:0"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Finalizing Results:</strong>&nbsp;&nbsp;&nbsp;{{ step === 5? stats.percentage_completion.toFixed(2) : step > 5? 100:0 }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="step === 5? stats.percentage_completion.toFixed(2) : step > 5? 100:0"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
                <b-list-group-item class="d-flex flex-column">
                  <span><strong>Overall Progress:</strong>&nbsp;&nbsp;&nbsp;{{ step < 5? step*20 : 80+(stats.percentage_completion.toFixed(2)/5) }}%</span>
                  <b-progress :max="100">
                    <b-progress-bar :value="step < 5? step*20 : 80+(stats.percentage_completion.toFixed(2)/5)"></b-progress-bar>
                  </b-progress>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right" cols="12">
              <div class="form-footer d-flex justify-content-between">
                <b-btn variant="info" size="sm" @click="setStage(1)" :disabled="step<5">
                  Back
                </b-btn>
                <b-btn v-if="stats.status > 6" variant="danger" size="sm" class="ml-auto mr-2" @click="delClassifiedData">
                  <i class="fa fa-trash" /> Discard
                </b-btn>
                <b-btn v-if="stats.status === 7" variant="warning" size="sm" class="mr-2" @click="startClassification">
                  Retry
                </b-btn>
                <b-btn v-if="stats.status === 8" variant="warning" size="sm" class="mr-2" @click="retryClassification">
                  Retry
                </b-btn>
                <b-btn variant="primary" size="sm" @click="getClassifiedData()" :disabled="step<5">
                  Review Results
                </b-btn>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="classificationStage === 3" class="categories-select">
        <b-col>
          <b-row>
            <b-col>
              <h5><b>Step 3:</b> Review &amp; Optimize Filter Grouping</h5>
              <!--<p>Curent task: <b-badge variant="creax">{{ stats.description }}</b-badge></p>-->
              <template v-if="clusteringValue">
                <h6 class="mt-4">Adjust clustering distance...</h6>
                <div class="distance-adjuster d-flex justify-content-between align-items-center mb-1">
                  <b-badge variant="outline-secondary">Narrow</b-badge>
                  <div style="width:60%">
                    <Slider
                        v-model="threshold"
                        :decimals="2"
                        :min="0.1"
                        :max="1.0"
                        :type="'distance'"
                        :tips="true"
                    ></Slider>
                  </div>
                  <b-badge variant="outline-secondary">Wide</b-badge>
                  <b-btn variant="outline-secondary" size="sm" @click="hideDistanceSlider()">Cancel</b-btn>
                  <b-btn variant="primary" size="sm" @click="applyDistanceClustering()">Apply</b-btn>
                </div>
              </template>
              <template v-if="filterInProcess">
                <h6 class="mt-4">Select Split Value</h6>
                <div class="distance-adjuster d-flex justify-content-between align-items-center mb-1">
                  <b-badge variant="outline-secondary">0%</b-badge>
                  <div style="width:60%">
                    <Slider
                        v-model="splitValue"
                        :decimals="2"
                        :min="0.1"
                        :max="100.0"
                        :type="'distance'"
                        :tips="true"
                    ></Slider>
                  </div>
                  <b-badge variant="outline-secondary">100%</b-badge>
                  <b-btn variant="outline-secondary" size="sm" @click="hideSplitSlider()">Cancel</b-btn>
                  <b-btn variant="primary" size="sm" @click="splitFilter()">Split</b-btn>
                </div>
              </template>
              <template v-if="merging">
                <h6 class="mt-4">Select One or More Filters To Merge</h6>
                <div class="distance-adjuster d-flex justify-content-start align-items-center mb-1">
                  <b-badge variant="outline-secondary" v-for="filt in mergeTray" :key="filt.id" class="elipsis">{{ filt.name }}</b-badge>
                  <b-btn variant="outline-secondary" size="sm" class="ml-auto" @click="hideMergeForm()">Cancel</b-btn>
                  <b-btn variant="primary" size="sm" class="ml-2" @click="mergeFilters()" :disabled="mergeTray.length < 2">Merge</b-btn>
                </div>
              </template>
              <template v-if="filterInRenameProcess">
                <h6 class="mt-4">Rename Filter</h6>
                <div class="distance-adjuster d-flex justify-content-between align-items-center mb-1">
                  <div style="width:60%">
                    <b-form-input placeholder="new name" v-model="renameValue" style="margin-bottom: 0"></b-form-input>
                  </div>
                  <b-btn variant="outline-secondary" size="sm" class="ml-auto" @click="hideRenameForm()">Cancel</b-btn>
                  <b-btn variant="primary" size="sm" class="ml-2" @click="renameFilter()">Rename</b-btn>
                </div>
              </template>
              <template v-if="!clusteringValue && !filterInProcess && !filterInRenameProcess && !merging">
                <h6 class="mt-4">Search classified data...</h6>
                <b-form-input placeholder="Search" :value="search || ''" @keyup="debounceSearch"></b-form-input>
              </template>
              <b-overlay :show="clustering" rounded="sm">
                <div class="treeview">
                    <div class="levels level_1" v-for="(cat, c) in contentData" :key="c">
                      <template v-if="true">
                        <div class="level d-flex">
                          <i v-if="search !== ''" class="icon mr-1 fas fa-square" />
                          <i v-else-if="treeOpened.indexOf(cat.category) > -1" class="icon mr-1 cursor-pointer far fa-minus-square" @click="toggleCat(cat.category)" />
                          <i v-else class="icon mr-1 cursor-pointer far fa-plus-square" @click="toggleCat(cat.category)" />
                          <i class="icon" :class="{'far fa-check-square': verifySelection(cat.category, null, null), 'far fa-square': !verifySelection(cat.category, null, null)}" @click="selectNode(cat.category, null, null)" />
                          <span>{{ cat.category }}</span>
                        </div>
                        <template v-if="treeOpened.includes(cat.category) || (search !== '')">
                          <div class="level_2" v-for="(sub, s) in cat.children" :key="s">
                            <template v-if="sub.children.length > 0">
                              <div class="level ml-2 d-flex">
                                <i v-if="search !== ''" class="icon mr-1 fas fa-square" />
                                <i v-else-if="subTreeOpened.indexOf(sub.subcategory) > -1" class="icon mr-1 cursor-pointer far fa-minus-square" @click="toggleSubCat(sub.subcategory)" />
                                <i v-else class="icon mr-1 cursor-pointer far fa-plus-square" @click="toggleSubCat(sub.subcategory)" />
                                <i class="icon" :class="{'far fa-check-square': verifySelection(null, sub.subcategory, null), 'far fa-square': !verifySelection(null, sub.subcategory, null)}" @click="selectNode(cat.category, sub.subcategory, null)" />
                                <span>{{ sub.subcategory }}</span> <b-badge size="sm" @click="selectForDcluster(cat.category, sub.subcategory, sub.threshold)" class="thold">{{ sub.threshold }} &nbsp;<i class="fas fa-pencil-alt"></i></b-badge>
                              </div>
                              <template v-if="subTreeOpened.includes(sub.subcategory) || (search !== '')">
                                <div class="level_3 classification" v-for="(filt, f) in sub.children" :key="f">
                                  <template v-if="filt['filter'].length > 0">
                                    <div class="level d-flex">
                                      <i v-if="filtTreeOpened.indexOf(filt.name) > -1" class="icon mr-1 cursor-pointer far fa-minus-square" @click="toggleFilter(filt.name)" />
                                      <i v-else class="icon mr-1 cursor-pointer far fa-plus-square" @click="toggleFilter(filt.name)" /> 
                                      <i class="icon" :class="{'far fa-check-square': verifySelection(null,null,filt._id), 'far fa-square': !verifySelection(null,null,filt._id)}" @click="selectNode(null, null, filt._id)" />
                                      <span :class="{'existing':checkFilterExist(filt.name),'highlighted': highlightedFilters.includes(filt._id), 'selected': mergeTray.find(f => { return filt.name === f.name })}">{{ filt.name }}</span> <b-badge class="namebt" size="sm" @click="showRenameForm(filt._id)"><i class="fas fa-pencil-alt"></i></b-badge> <b-badge v-if="filt['filter'].length > 1" class="splitbt" size="sm" @click="showSplitSlider(filt._id)">Split</b-badge> <b-badge class="mergebt" size="sm" @click="showMergeForm({id: filt._id, name: filt.name})">{{ mergeTray.find(t => { return t.id === filt._id })? 'Remove from Merge':'Add to Merge' }}</b-badge><br />
                                      <div class="concepts" v-if="filt['filter'].length && filtTreeOpened[0] === filt.name">
                                        <b-badge v-for="(concept, c) in filt['filter'].filter(f => f.ttc_id)" :key="c" size="sm" v-b-tooltip.hover :title="`${concept.reasoning}`" :class="{'matched': concept.matched}">{{ concept.name }} <strong> {{ concept.similarity_percentage }}%</strong> <i class="fa fa-times" @click="removeConcept(filt._id, concept.ttc_id, concept.name, 'del')" /></b-badge>
                                        <b-badge size="sm" class="addbt" @click="addConcept(filt._id)">Add</b-badge>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>
                    </div>
                </div>
              </b-overlay>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right" cols="12">
              <div class="form-footer d-flex  justify-content-start">
                <b-btn variant="info" size="sm" @click="setStage(1)" :disabled="step<5">
                  Back
                </b-btn>
                <b-btn variant="danger" size="sm" class="mr-auto ml-2" @click="delClassifiedData">
                  <i class="fa fa-trash" /> Discard
                </b-btn>
                <xlsx-workbook>
                  <xlsx-sheet
                    :collection="exportData"
                    :sheet-name="'Classified Concepts'"
                  />
                  <xlsx-download>
                    <b-btn variant="primary" size="sm" class="ml-2" @click="exportClassification()">
                      <i class="fa fa-download" /> Export
                    </b-btn>
                  </xlsx-download>
                </xlsx-workbook>
                <b-btn variant="primary" size="sm" class="ml-2" @click="setClassifiedFilters()" :disabled="tree.cSelected.length === 0 && tree.sSelected.length === 0 && tree.selected.length === 0">
                  <i class="fas fa-filter" /> CreateFilters
                </b-btn>
              </div>
            </b-col>
            <b-col cols="12">
              <p class="mt-2 text-warning">* Filter names already exists.</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Topic Modal for entering topic if missing -->
      <TopicModal ref="topicModal" />
      <ConceptSearchAutoModal @addToQuery="addToQuery"></ConceptSearchAutoModal>

    </b-overlay>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from "vue-xlsx";
import { addCounts } from "../../../helpers/PrepFilters";
import Slider from "../Shared/Slider.vue";
import DataSettings from "@/helpers/DataSettings";
import ConceptSearchAutoModal from "../ExploreSidebar/Modals/ConceptSearchAutoModal.vue";
import TopicModal from "../Shared/TopicModal";

export default {
  name: "AutoClassification",
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    Slider,
    ConceptSearchAutoModal,
    TopicModal
  },
  data() {
    return {
      showCatForm: false,
      classifiedKey: "reviewed_autofilter_results",
      catEditing: null,
      subcatEditing: null,
      classificationCompStatus: true,
      batchingProgress: false,
      batchingProgressValue: 0,
      batchingProgressMsg: "",
      step:0,
      search: "",
      form: {
        catname: null,
        catdesc: null,
        subcatname: null,
        subcatdesc: null,
        description: null,
        objective: null,
        method: "chat",
        chunking: "default"
      },
      options: [
          { value: "chat", text: 'Chat Completion Api - 4o-mini' },
          { value: 'batch', text: 'Batch Api - 4o-mini' },
          { value: 'assistant', text: 'Assistant Api - 4o-mini' },
          { value: 'assistant-qdrant', text: 'Assistant Api (With Qdrant) - 4o-mini' }
      ],
      ch_options: [
          { value: "default", text: 'Sequential Pick' },
          { value: 'topic', text: 'Topic' }
      ],
      categories: [],
      tree: {
        selected: [],
        sSelected: [],
        cSelected: []
      },
      clusteringValue: null,
      treeOpened: [],
      subTreeOpened: [],
      filtTreeOpened: [],
      intervalToCheck: null,
      classifiedData: null,
      contentData: null,
      exportData: [],
      activeCat: null,
      clustering: false,
      merging: false,
      mergeTray: [],
      threshold: [0.5],
      splitValue: [50.0],
      filterInProcess: null,
      renameValue: "",
      filterInRenameProcess: null,
      filterAddConcepts: null,
      selectedFiltersForImport: [],
      highlightedFilters: [],
      reviewedResults: {}
    }
  },
  computed: {
    ...mapGetters([
      "modelTopic"
    ]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      classificationStatus: (state) => state.classification.classificationStatus,
      batchingStatus: (state) => state.classification.batchingStatus,
      classificationStage: (state) => state.classification.currentStage,
      stats: (state) => state.classification.stats,
      settings: (state) => state.setting.dataSettings,
      importedFilters: (state) => state.filter.importedFilters,
      filterNames: (state) => state.filter.filterNames
    }),
  },
  mounted() {
    this.getBatchingStatus(this.apiId).then(() => {
      if(this.batchingStatus === 'No'){
        this.getBatchingProgress(this.apiId).then(res => {
          if(res && res.progress < 100){
            this.batchingProgress = true;
            this.batchingProgressValue = res.progress;
            this.batchingProgressMsg = res.description;
            this.checkBatchingProgress();
          }
        })
      }
      this.getClassificationStatus(this.apiId).then(res => {
        if(res && res.status && res.status > 1){
          this.step = res.status;

          if(this.step === 6){
            this.getClassifiedData();
          }
          else{
            this.setStage(2);
          }
          //this.setClassificationStage(res.status);
          if (res.status === 5){
            if (this.reviewedResults[this.apiId]){
              this.getClassifiedData();
            }
          }
          this.setClassificationStatus(true);
          this.checkClassificationStatus();
          this.classificationCompStatus = false;
        }
        else{
          this.setClassificationStage(0);
          this.classificationCompStatus = false;
        }
        
        if(this.settings.filters && this.settings.filters.autoFiltCats && this.settings.filters.autoFiltCats.length){
          this.categories = this.settings.filters.autoFiltCats;
        }
        // else{
        //   this.categories = [
        //     { title: "Others", description: "All n-grams which doesnt fall into any category", subcats: [
        //       { title: "Others", description: "All n-grams which doesnt fall into any category" }
        //     ] }
        //   ];
        // }
      })
    })
  },
  created(){
    const stored = localStorage.getItem(this.classifiedKey);
    this.reviewedResults = stored ? JSON.parse(stored): {};
    console.log("Created hook: reviewedResults loaded", this.reviewedResults);
  },
  destroyed() {
    clearInterval(this.intervalToCheck);
  },
  methods: {
    ...mapActions([
      "initiateClassification",
      "restartClassification",
      "getClassificationStatus",
      "initiateManualBatching",
      "getBatchingStatus",
      "getBatchingProgress",
      "getClassificationData",
      "clusterClassifiedData",
      "getClassifiedFilters",
      "setClassificationStatus",
      "setClassificationStage",
      "delClassificationData",
      "updateClassifiedFilter",
      "mergeClassifiedFilters",
      "splitClassifiedFilter",
      "renameClassifiedFilter",
      "saveImpFilters",
      "saveBulkImportedFilters",
      "loadAnimStart",
      "loadAnimEnd",
      "saveLoadingStep",
      "getCatDescription"
    ]),
    showCategory() {
      this.showCatForm = !this.showCatForm;
      this.catEditing = null;
      this.form.catname = null;
      this.form.catdesc = null;
    },
    addCategory(n) {
      if(!this.form.catname || !this.form.catdesc){
        this.$toasted.show("Category name and description cant be empty!", {
          type: "error",
        });
      }
      else if(_.find(this.categories, c => { return c.title === this.form.catname })){
        if(n!==null){
          this.categories[n].description = this.form.catdesc;
          this.form.catname = null;
          this.form.catdesc = null;
          this.showCatForm = false;
          this.catEditing = null;
          DataSettings.setSettings("filters.autoFiltCats", this.categories);
        }
        else{
          this.form.catname = null;
          this.form.catdesc = null;
          this.$refs.catname.focus();
          this.$toasted.show("Category already exists", {
            type: "error",
          });
        }
      }
      else{
        if(n!==null){
          this.categories[n].title = this.form.catname;
          this.categories[n].description = this.form.catdesc;
        }
        else{
          this.categories.push({ title: this.form.catname,  description: this.form.catdesc, subcats: [] });
          // this.categories.unshift({ title: this.form.catname,  description: this.form.catdesc, subcats: [] });
        }
        this.form.catname = null;
        this.form.catdesc = null;
        this.$refs.catname.focus();
        this.showCatForm = false;
        this.catEditing = null;
        DataSettings.setSettings("filters.autoFiltCats", this.categories);
      }
    },
    suggestDescription(name, n){
      this.classificationCompStatus = true;
      this.getCatDescription({
        category: name,
        model_id: this.apiId,
        topic: this.modelTopic
      }).then(res => {
        if(res && res.response){
          if(n === 0){
            this.form.catdesc = res.response;
          }
          else{
            this.form.subcatdesc = res.response;
          }
          this.classificationCompStatus = false;
        }
        else{
          this.$toasted.show("No suitable description to suggest!", {
            type: "error",
          });
          this.classificationCompStatus = false;
        }
      })
    },
    editCategory(n) {
        this.catEditing = n;
        this.form.catname = this.categories[n].title;
        this.form.catdesc = this.categories[n].description;
        this.showCatForm = true;
    },
    removeCategory(n) {
      this.categories.splice(n, 1);
      DataSettings.setSettings("filters.autoFiltCats", this.categories);
    },
    addSubCategory(n, s) {
      if(!this.form.subcatname || !this.form.subcatdesc){
        this.$toasted.show("Subcategory name and description cant be empty!", {
          type: "error",
        });
      }
      else if(_.find(this.categories[n].subcats, c => { return c.title === this.form.subcatname })){
        if(s!==null){
          this.categories[n].subcats[s].description = this.form.subcatdesc;
          this.form.subcatname = null;
          this.form.subcatdesc = null;
          this.subcatEditing = null;
          this.activateBlock(null);
          DataSettings.setSettings("filters.autoFiltCats", this.categories);
        }
        else{
          this.form.subcatname = null;
          this.form.subcatdesc = null;
          //this.$refs["subcatname"+n].focus();
          this.$toasted.show("Subcategory already exists", {
            type: "error",
          });
        }
      }
      else{
        if(s!==null){
          this.categories[n].subcats[s].title = this.form.subcatname;
          this.categories[n].subcats[s].description = this.form.subcatdesc;
        }
        else{
          this.categories[n].subcats.push({ title: this.form.subcatname,  description: this.form.subcatdesc });
        }
        this.form.subcatname = null;
        this.form.subcatdesc = null;
        this.activateBlock(null);
        DataSettings.setSettings("filters.autoFiltCats", this.categories);
      }
    },
    editSubCategory(n, s) {
        this.subcatEditing = s;
        this.form.subcatname = this.categories[n].subcats[s].title;
        this.form.subcatdesc = this.categories[n].subcats[s].description;
        this.activateBlock(n);
    },
    removeSubCategory(n, s) {
      this.categories[n].subcats.splice(s, 1);
      DataSettings.setSettings("filters.autoFiltCats", this.categories);
    },
    classificationReady(list){
      //console.log(list);
        if (!Array.isArray(list) || list.length === 0) {
            return false;
        }
        for (let element of list) {
            if (!element) {
                return false;
            }
            if (element.subcats && !this.classificationReady(element.subcats)) {
                return false;
            }
        }
        return true;
    },
    startBatching(){
      this.initiateManualBatching({ model_id: this.apiId }).then(res => {
        this.$toasted.show("Batching started", { type: "success" });
        this.checkBatchingProgress();
      }).catch(error => {
        this.$toasted.show("Error starting batching", { type: "error" });
      });
    },
    persistReviewedResults(){
      localStorage.setItem(
        this.classifiedKey, JSON.stringify(this.reviewedResults)
      )
    },
    removeReviewedResult(apiId){

      if (!this.classifiedKey || !apiId) return;

      const updatedResults = { ...this.reviewedResults};
      
      if (!updatedResults.hasOwnProperty(apiId)) return;

      delete updatedResults[apiId];
      
      this.reviewedResults = updatedResults;

      localStorage.setItem(this.classifiedKey, JSON.stringify(this.reviewedResults));

    },
    startClassification(){
      if(this.classificationReady(this.categories)){
        this.classificationCompStatus = true;
        this.initiateClassification({
          categories: this.categories,
          model_id: this.apiId
          //description: this.form.description,
          //objective: this.form.objective,
          //method: this.form.method,
          //chunking: this.form.chunking
        }).then(res => {
          this.setStage(2)
          this.setClassificationStatus(true)
          this.checkClassificationStatus()
          this.classificationCompStatus = false;
        })
      }
      else{
        this.$toasted.show("Invalid Input! Missing subcategory for any category", {
          type: "error",
        });
      }
    },
    retryClassification(){
      if(this.classificationReady(this.categories)){
        this.classificationCompStatus = true;
        this.removeReviewedResult(this.apiId);
        this.restartClassification({
          categories: this.categories,
          model_id: this.apiId
          //description: this.form.description,
          //objective: this.form.objective,
          //method: this.form.method,
          //chunking: this.form.chunking
        }).then(res => {
          this.setStage(2)
          this.setClassificationStatus(true)
          this.checkClassificationStatus()
          this.classificationCompStatus = false;
        })
      }
      else{
        this.$toasted.show("Invalid Input! Missing subcategory for any category", {
          type: "error",
        });
      }
    },
    checkClassificationStatus(){
      this.intervalToCheck = setInterval(() => {
        this.getClassificationStatus(this.apiId).then(res => {
          this.step = res.status;
          if(res.status && res.status === 5 && res.percentage_completion === 100){
            clearInterval(this.intervalToCheck);
          }
        })
      }, 5000)
    },
    checkBatchingProgress(){
      this.batchingProgress = true;
      this.intervalToCheck = setInterval(() => {
        this.getBatchingProgress(this.apiId).then(res => {
          if(res && res.progress < 100){
            this.batchingProgressValue = res.progress;
            this.batchingProgressMsg = res.description;
          }
          else{
            clearInterval(this.intervalToCheck);
            this.batchingProgress = false;
            this.getBatchingStatus(this.apiId);
          }
        })
      }, 5000)
    },
    applyDistanceClustering(){
      this.hideMergeForm();
      this.hideSplitSlider();
      this.hideRenameForm();
      this.clustering = true;
      const data = {
        category: this.clusteringValue.category,
        subcategory: this.clusteringValue.subcategory,
        threshold: this.threshold[0],
        model_id: this.apiId
      }
      this.clusterClassifiedData(data).then(res =>{
        this.clustering = false;
        this.hideDistanceSlider();
        this.classifiedData = res;
        this.contentData = this.classifiedData;
        this.setStage(3);
      })
    },
    hideDistanceSlider(){
      this.clusteringValue = null;
    },
    showMergeForm(filt){
      this.merging = true;
      if(this.mergeTray.find(f => { return f.id === filt.id })){
        this.mergeTray = this.mergeTray.filter(f => { return f.id !== filt.id })
      }
      else{
        this.mergeTray.push(filt);
      }
      this.hideDistanceSlider();
      this.hideSplitSlider();
      this.hideRenameForm();
    },
    hideMergeForm(){
      this.mergeTray = [];
      this.merging = false;
    },
    mergeFilters(){
      this.mergeClassifiedFilters({
        model_id: this.apiId,
        filter_ids: this.mergeTray.map(f => { return f.id })
      }).then(res => {
        this.highlightedFilters = [res.Filter_id];
        this.removeHighlighting();
        this.getClassifiedData();
        this.hideMergeForm();
        this.$toasted.show("Merge Filters Successfully!", {
          type: "success",
        });
      })
    },
    showSplitSlider(filt){
      this.hideDistanceSlider();
      this.hideMergeForm();
      this.hideRenameForm();
      this.filterInProcess = filt;
    },
    hideSplitSlider(){
      this.filterInProcess = null;
    },
    splitFilter(){
      this.splitClassifiedFilter({
        model_id: this.apiId,
        filter_id: this.filterInProcess,
        threshold: this.splitValue[0]
      }).then(res => {
        this.highlightedFilters = [res.Old_Filter_Id, res.Split_Filter_Id];
        this.removeHighlighting();
        this.getClassifiedData();
        this.hideSplitSlider();
        this.$toasted.show("Filter Split Successfull!", {
          type: "success",
        });
      })
    },
    addToQuery(type, arr){
      console.log(type);
      arr.forEach((con, c) => {
        this.updateClassifiedFilter({
          model_id: this.apiId,
          filter_id: this.filterAddConcepts,
          title: con.title,
          ttc_id: con.id,
          task: "add"
        }).then(res => {
          if(arr.length === c+1){
            this.getClassifiedData();
            this.$toasted.show("Concept(s) Added", {
              type: "success",
            });
            this.filterAddConcepts = null;
          }
        })
      });
    },
    addConcept(filt){
      this.filterAddConcepts = filt;
      this.$bvModal.show("modal-ttc-concept-auto");
    },
    removeConcept(filt, id, name, task){
      this.updateClassifiedFilter({
        model_id: this.apiId,
        filter_id: filt,
        title: name,
        ttc_id: id,
        task: task
      }).then(res => {
        this.getClassifiedData();
        this.$toasted.show("Concept Removed", {
          type: "success",
        });
      })
    },
    showRenameForm(filt){
      this.hideDistanceSlider();
      this.hideSplitSlider();
      this.hideMergeForm();
      this.filterInRenameProcess = filt;
    },
    hideRenameForm(){
      this.filterInRenameProcess = null;
      this.renameValue = "";
    },
    renameFilter(){
      this.renameClassifiedFilter({
        model_id: this.apiId,
        filter_id: this.filterInRenameProcess,
        title: this.renameValue
      }).then(res => {
        this.hideRenameForm();
        this.getClassifiedData();
        this.$toasted.show("Filter Renamed", {
          type: "success",
        });
      })
    },
    removeHighlighting(){
      setInterval(() => {
        this.highlightedFilters = [];
      }, 10000);
    },
    setClassifiedFilters(){
      this.saveLoadingStep("Preparing Filters");
      this.loadAnimStart();
      this.getClassifiedFilters({ model_id: this.apiId, filters: this.tree.selected }).then(async res => {
        //const shortlisted = await this.shortlistFilters(res.categories);
        //console.log(shortlisted);
        const imported = addCounts(res);
        this.saveImpFilters({ filters: imported });
        await this.prepareFiltersImport();
        //this.saveLoadingStep("");
      })
    },
    async prepareFiltersImport(){
      this.selectedFiltersForImport = [];
      return new Promise((resolve) => {
        this.importedFilters.forEach((c, ci) =>{
          c.children.forEach((s, si) => {
            s.children.forEach((f, fi) => {
              this.selectedFiltersForImport.push({
                id: f.id,
                cat: c,
                subcat: s,
                filter: f,
                ci: ci,
                si: si,
                fi: fi
              });
            })
          })
          if(this.importedFilters.length > ci){
            this.saveSelectedImpFilters();
            //this.loadAnimEnd();
            resolve();
          }
        })
      })
    },
    async saveSelectedImpFilters(){
      //this.loadAnimStart();
      this.saveLoadingStep("Saving.....");
      let payloadList = [];
      //let itr = 0;
      this.selectedFiltersForImport.forEach(async (impFilt, itr) => {
        const cat = impFilt.cat;
        const subcat = impFilt.subcat;
        const filt = impFilt.filter;
        const cati = impFilt.ci;
        const subi = impFilt.si;
        const filti = impFilt.fi;
        if(filt.matched !== 0){
          let fname =
            this.importedFilters[cati].children[subi].children[filti].name;
          let frawquery =
            this.importedFilters[cati].children[subi].children[filti].rawquery;
          let fcleanquery = this.cleanQuery(frawquery);
          let ftype =
            this.importedFilters[cati].children[subi].children[filti].type;
          
                  let filter = {
                    //name: filtfound? fname + "_" + Math.random().toString().slice(-3, -1):fname,
                    name: fname,
                    query: fcleanquery,
                    type: "filter",
                  };

                  payloadList.push({
                    filter: filter,
                    //category: catfound? { _id: catfound.id }:{ name: this.importedFilters[cati].name },
                    //subcategory: subcatfound? { _id: subcatfound.id }: { name: this.importedFilters[cati].children[subi].name },
                    //name: filtfound? fname + "_" + Math.random().toString().slice(-3, -1):fname,
                    category: { name: this.importedFilters[cati].name },
                    subcategory: { name: this.importedFilters[cati].children[subi].name },
                    //name: fname,
                    //rawquery: frawquery,
                    //type: ftype
                  });  
                
        }
        if(this.selectedFiltersForImport.length === itr+1){
          const chunkSize = 10;
          for (let i = 0; i < payloadList.length; i += chunkSize) {
            const chunk = payloadList.slice(i, i + chunkSize);
            this.saveLoadingStep(`Saving filters ${i + 1}-${Math.min(i + chunk.length, payloadList.length)} of ${payloadList.length}`);
            await this.saveBulkImportedFilters(chunk);
            if (i + chunkSize >= payloadList.length) {
              setTimeout(() => { this.saveLoadingStep("All filters saved! Process complete."); this.loadAnimEnd() }, 1000);
              this.selectedFiltersForImport = [];
              this.saveImpFilters({ filters: { categories: [] } });
            }
          }
        }
      })
    },
    cleanQuery(rq) {
      let cq = [];
      rq.forEach((el) => {
        if (el !== "OR" && el._id !== "TTC_XXX") {
          cq.push(el);
          cq.push("OR");
        }
      });
      cq.pop();
      return cq;
    },
    getClassifiedData(){
      this.clustering = true;

      this.$set(this.reviewedResults, this.apiId, true);
      this.persistReviewedResults();
      
      this.getClassificationData(this.apiId).then(res => {
        console.log("Apid Id " + this.apiId)
        this.classifiedData = res;
        this.contentData = this.classifiedData;
        this.clustering = false;
        this.setStage(3);
      })
    },
    delClassifiedData(){
      this.$bvModal
        .msgBoxConfirm(
          `All auto-filtering process will be erased including categories and subcategories. Are you sure you want to continue?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
          this.delClassificationData(this.apiId).then(() => {
            if (localStorage.getItem(this.classifiedKey)!== null){
              this.removeReviewedResult(this.apiId);
            }
            this.getClassificationStatus(this.apiId).then(() => {
              this.categories = [];
              DataSettings.setSettings("filters.autoFiltCats", this.categories);
              DataSettings.setSettings("filters.topic", null);
              this.$toasted.show("Classification Data Cleared Successfully!", {
                type: "warning",
              });
              this.setStage(0);
            })
          })
          }
        });
    },
    debounceSearch: _.debounce(function (e) {
      this.contentData = JSON.parse(JSON.stringify(this.classifiedData));
      this.search = e ? e.target.value.trim() : "";
      if(this.search !== ""){
        this.contentData.forEach((c, ci) => {
          c.children.forEach((s, si) => {
            s.children.forEach((f, fi) => {
              const result = _.filter(f.filter, c => { return c.name.includes(this.search); });
              f.filter = result.length > 0 ? f.filter : [];
            })
          })
        })
      }
      /*if(this.search !== ""){
        this.contentData.forEach((c, ci) => {
          c.children.forEach((s, si) => {
            s.children.forEach((f, fi) => {
              f.filter = f.filter.map(c => {
                return {
                  ...c,
                  matched: c.name.includes(this.search)
                };
              });
            })
          })
        })
      }
      else {
        // Reset matched flag when search is empty
        this.contentData.forEach((c, ci) => {
          c.children.forEach((s, si) => {
            s.children.forEach((f, fi) => {
              f.filter = f.filter.map(c => {
                return {
                  ...c,
                  matched: false
                };
              });
            })
          })
        })
      }*/
    }, 400),
    selectNode(c, s, f){
      if(c){
        if(s){
          if(!this.tree.cSelected.includes(c)){
            this.tree.cSelected.push(c);
          }
          if(this.tree.sSelected.includes(s)){
            let sIndex = this.tree.sSelected.indexOf(s);
            this.tree.sSelected.splice(sIndex, 1);
            this.contentData.forEach(cat => {
              cat.children.forEach(sub => {
                if(sub.subcategory === s){
                  sub.children.forEach(filt => {
                    let fi = this.tree.selected.indexOf(filt._id);
                    this.tree.selected.splice(fi, 1);
                  })
                }
              })
            })
          }
          else{
            this.tree.sSelected.push(s);
            this.contentData.forEach(cat => {
              cat.children.forEach(sub => {
                if(sub.subcategory === s){
                  sub.children.forEach(filt => {
                    this.tree.selected.push(filt._id);
                  })
                }
              })
            })
          }
        }
        else{
          if(this.tree.cSelected.includes(c)){
            let cIndex = this.tree.cSelected.indexOf(c);
            this.tree.cSelected.splice(cIndex, 1);
            this.contentData.forEach(cat => {
              if(cat.category === c){
                cat.children.forEach(sub => {
                  let si = this.tree.sSelected.indexOf(sub.subcategory);
                  this.tree.sSelected.splice(si, 1);
                  sub.children.forEach(filt => {
                    let fi = this.tree.selected.indexOf(filt._id);
                    this.tree.selected.splice(fi, 1);
                  })
                })
              }
            })
          }
          else{
            this.tree.cSelected.push(c);
            this.contentData.forEach(cat => {
              if(cat.category === c){
                cat.children.forEach(sub => {
                  this.tree.sSelected.push(sub.subcategory);
                  sub.children.forEach(filt => {
                    this.tree.selected.push(filt._id);
                  })
                })
              }
            })
          }
        }
      }
      else{
        if(this.tree.selected.includes(f)){
          let index = this.tree.selected.indexOf(f);
          this.tree.selected.splice(index, 1);
        }
        else{
          this.tree.selected.push(f);
        }
      }
    },
    selectForDcluster(c, s, v){
      if(this.clusteringValue && this.clusteringValue.subcategory === s){
        this.clusteringValue = null;
      }
      else{
        this.threshold = [v];
        this.clusteringValue = {
          category: c,
          subcategory: s,
          value: v
        };
      }
    },
    verifySelection(c,s,f){
      if(c){
        if(this.tree.cSelected.includes(c)){
          return true;
        }
        else{
          return false;
        }
      }
      if(s){
        if(this.tree.sSelected.includes(s)){
          return true;
        }
        else{
          return false;
        }
      }
      if(f){
        if(this.tree.selected.includes(f)){
          return true;
        }
        else{
          return false;
        }
      }
    },
    checkFilterExist(name){
      return this.filterNames.includes(name);
    },
    toggleCat(c){
      if(this.treeOpened.includes(c)){
        this.treeOpened.splice(this.treeOpened.indexOf(c), 1)
      }
      else{
        this.treeOpened = [c];
      }
    },
    toggleSubCat(s){
      if(this.subTreeOpened.includes(s)){
        this.subTreeOpened.splice(this.subTreeOpened.indexOf(s), 1)
      }
      else{
        this.subTreeOpened = [s];
      }
    },
    toggleFilter(f){
      if(this.filtTreeOpened.includes(f)){
        this.filtTreeOpened.splice(this.filtTreeOpened.indexOf(f), 1)
      }
      else{
        this.filtTreeOpened = [f];
      }
    },
    setStage(s){
      this.setClassificationStage(s);
      if(s===4){
        this.$toasted.show("Filter creation process initiated. this may take while!", {
          type: "warning",
        });
        this.setClassificationStage(0);
      }
      if(s===0){
        /*this.$toasted.show("Warning!", {
          type: "warning",
        });*/
      }
      if(s===3){
        //this.exportClassification();
      }
    },
    exportClassification(){
      this.exportData = [];
      this.contentData.forEach(cat => {
        cat.children.forEach(sub => {
          sub.children.forEach(item => {
            this.exportData.push({
              Category: cat.category,
              Subcategory: sub.subcategory,
              Filtername: item.name,
              Concepts: item['filter'].map(i => { if(i.ttc_id) { return i.name } }).join("|"),
            });
          })
        })
      });
    },
    isActive(n){
      const st = (this.activeCat !== null && this.activeCat === n)? true:false;
      return st;
    },
    activateBlock(n){
      this.activeCat = n;
      if(!n){
        this.catEditing = null;
        this.subcatEditing = null;
        this.form.subcatname = null;
        this.form.subcatdesc = null;
      }
    },
    openTopicModal() {
      this.$refs.topicModal.show(this.modelTopic || "");
    },
  }
};
</script>
